import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import OverviewVideo360 from "./components/OverviewVideo360";
import Viewer360 from "./components/Viewer360";
import CenterViewer360 from "./components/CenterViewer360";
function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={<OverviewVideo360 />}
        />
        <Route
          path="/:topic"
          element={<Viewer360 />}
        />
        <Route
          path="/center/:center"
          element={<CenterViewer360 />}
        />
      </Routes>
    </Router>
  );
}

export default App;
